import React from 'react';

export default function DeleteSVG() {
  return (
    <svg
      height="15"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.55888 7.17798C7.77774 7.17798 7.95516 7.35505 7.95516 7.57349V12.3196C7.95516 12.538 7.77774 12.7151 7.55888 12.7151C7.34002 12.7151 7.1626 12.538 7.1626 12.3196V7.57349C7.1626 7.35505 7.34002 7.17798 7.55888 7.17798Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99291 7.17997C5.20966 7.15824 5.40295 7.31681 5.42462 7.53416L5.89794 12.2802C5.91961 12.4975 5.76147 12.6914 5.54472 12.7131C5.32796 12.7348 5.13467 12.5763 5.113 12.3589L4.63968 7.61287C4.61801 7.39552 4.77615 7.20171 4.99291 7.17997Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1243 7.17997C10.3411 7.20171 10.4992 7.39552 10.4775 7.61287L10.0042 12.3589C9.98254 12.5763 9.78925 12.7348 9.5725 12.7131C9.35574 12.6914 9.1976 12.4975 9.21927 12.2802L9.69259 7.53416C9.71426 7.31681 9.90755 7.15824 10.1243 7.17997Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.2373C0 3.01887 0.17673 2.8418 0.394737 2.8418H14.6053C14.8233 2.8418 15 3.01887 15 3.2373C15 3.45574 14.8233 3.63281 14.6053 3.63281H0.394737C0.17673 3.63281 0 3.45574 0 3.2373Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4.74634C0 4.536 0.17673 4.36548 0.394737 4.36548H14.6053C14.8233 4.36548 15 4.536 15 4.74634C15 4.95668 14.8233 5.1272 14.6053 5.1272H0.394737C0.17673 5.1272 0 4.95668 0 4.74634Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.4492 0.956655C3.67387 0.379901 4.23015 0 4.85001 0H10.2961C10.916 0 11.4723 0.379902 11.697 0.956656L12.7394 3.63281H2.40674L3.4492 0.956655ZM4.85001 0.789742C4.55639 0.789742 4.29289 0.969695 4.18647 1.24289L3.56314 2.84307H11.583L10.9597 1.24289C10.8533 0.969696 10.5898 0.789742 10.2961 0.789742H4.85001Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.23096 4.42383H13.0627L12.1534 14.2509C12.0895 14.9409 11.5092 15.4688 10.8146 15.4688H4.47899C3.78437 15.4688 3.20411 14.9409 3.14026 14.2509L2.23096 4.42383ZM3.09815 5.21275L3.92775 14.1783C3.95404 14.4625 4.19297 14.6798 4.47899 14.6798H10.8146C11.1006 14.6798 11.3396 14.4625 11.3659 14.1783L12.1955 5.21275H3.09815Z"
        fill="currentColor"
      />
    </svg>
  );
}
